import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client — refetch intervals adapted to the
 * polling strategy declared in docs/product/screens.md §3.3.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Conservative defaults; per-query overrides set the polling cadence.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
